import { ColumnDef } from "@tanstack/react-table"
import React from "react"
import { FormattedMessage } from "react-intl"
import { TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"

export default (): Partial<ColumnDef<TableRowData>> => ({
    cell: info => (
        info.getValue() ? (
            <FormattedMessage
                id="generic-listing.boolean-cell-mapper.yes"
                defaultMessage="Yes"
            />
        ) : (
            <FormattedMessage
                id="generic-listing.boolean-cell-mapper.no"
                defaultMessage="No"
            />
        )
    )
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/BooleanCellMapper.tsx